import { useState, useEffect } from "react";
import KeyIcon from "@mui/icons-material/Key";
import get_token from "../lib/get_token";
import get_cid from "../lib/get_cid";
import { configState } from "../lib/State";
import axios from "axios";
import send_webview_data from "../lib/send_webview_data";
import get_center from "../lib/get_center";
import Swal from "sweetalert2";

function HomeDoor(props) {
  const { login } = props;
  const [showButton, setShowButton] = useState(true);
  const token = get_token();
  const cid = get_cid();
  const center = get_center(cid);
  const [smart_key, setSmartKey] = useState(false); // 스마트키

  const open_door = () => {
    Swal.fire({
      title: "두써킷센터",
      html: "출입문을 개방하시겠습니까?",
      showConfirmButton: true,
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        send_webview_data({
          id: "door_open",
          value: login.mcd,
          cid: center.door_id,
        });
      }
    });
  };

  const load_data = async () => {
    let result = await axios.post(configState.api + "/gympass/get_key", {
      token: token,
      cid: cid,
      mcd: login.mcd,
      level: login.level,
    });
    if (result.data.success === 1 && result.data.smart_key === "Y") {
      setSmartKey(true);
    }
  };

  useEffect(() => {
    if (login.mcd !== "") {
      load_data();
    }
  }, [login.mcd]);

  return (
    center.pass_coupon_sale &&
    smart_key && (
      <div className="fixed bottom-[78px] right-0 z-10">
        <div
          className="text-white shadow-[0_2px_10px_rgba(0,0,0,0.3)] rounded-l-full overflow-hidden z-10 flex items-stretch transition-transform"
          style={{
            transform: `translate(${showButton ? "0" : "153.28px"}, 0)`,
          }}
        >
          <button
            className="p-4 bg-white text-[#00b375]"
            onClick={() => setShowButton(!showButton)}
          >
            <KeyIcon />
          </button>
          <button
            className="bg-[#00b375] flex items-center px-5 font-semibold text-lg"
            onClick={open_door}
          >
            패스쿠폰 문열기
          </button>
        </div>
      </div>
    )
  );
}

export default HomeDoor;
